import packageInfo from '../../../../package.json'
export const environment = {
  production: false,
  version: packageInfo.version,
  firebaseConfig:{
    apiKey: "AIzaSyDyfZ_xyCp3vHLW0fAoljwKlIzSDpc7-3I",
    authDomain: "qventanacode-develop.firebaseapp.com",
    projectId: "qventanacode-develop",
    storageBucket: "qventanacode-develop.appspot.com",
    messagingSenderId: "434693211697",
    appId: "1:434693211697:web:0ec54ff9f86c4ece9df710"
  },
  apiServer: {
    url: 'https://qventanacode-develop.a2system.net/',
    projectId: "qventanacode-develop"
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
